import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';
import { useSelector } from 'react-redux';

// Import helrpes
import { bannersTabs } from './helpers/index';

const BannersTabs = () => {
	const { languages: contentTranslationLanguages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);
	return <Tabs tabs={bannersTabs(contentTranslationLanguages)} />;
};

export default BannersTabs;
